import { Option } from "../components/customform/types";
import { Field } from "../models/Fields";

export const convertFieldToMappedFieldOptions = (field: Field | undefined) => {
  const data = new Map<number, string>();
  if (field && field.fieldOptions) {
    field.fieldOptions.forEach((option) => {
      data.set(option.id, option.name);
    });
  }
  return data;
};

export const convertSymptomCodesToSymptomNameMap = (fields: Field[]) => {
  const data = new Map<string, string>();
  fields.forEach((field) => {
    data.set(field.alias, field.header);
  });
  return data;
};

export const convertFieldToFieldOptionsList = (
  field: Field | undefined,
  sortProp?: keyof Option,
  direction: "asc" | "desc" = "asc"
) => {
  const data: Option[] = [];
  if (field && field.fieldOptions) {
    field.fieldOptions.forEach((option) => {
      data.push({
        id: String(option.id),
        name: option.name,
      });
    });
  }

  if (sortProp) {
    data.sort((a, b) => {
      const compare =
        a[sortProp] < b[sortProp] ? -1 : a[sortProp] > b[sortProp] ? 1 : 0;
      return direction === "asc" ? compare : -compare;
    });
  }

  return data;
};

export const translateNoteFieldAlias = (fieldAlias: string) => {
  switch (fieldAlias) {
    case "D_PERComments":
      return "Kommentar";
    case "D_PERDiagnos":
      return "Diagnos";
    case "D_PERDrugs":
      return "Läkemedel";
    default:
      return "";
  }
};

export const symptomFields = [
  "C_F_D_Diary_DryCough",
  "C_F_D_Diary_ThroatPain",
  "C_F_D_Diary_StomachAche",
  "C_F_D_Diary_MorningCough",
  "C_F_D_Diary_FlemCough",
  "C_F_D_Diary_Fever",
  "C_F_D_Diary_FeelingSick",
  "C_F_D_Diary_EarPain",
  "C_F_D_Diary_Cold",
  "C_F_D_Diary_Tiredness",
  "C_F_D_Diary_NoSymtom",
] as string[];

export const noteFields = [
  "D_PERComments",
  "D_PERDrugs",
  "D_PERDiagnos",
] as string[];
